import { PaletteEntry } from "@components/palette_entry/palette_entry";
import { ICON_NAMES } from "@root/types";
import React, { type FC } from "react";

const PalettePage: FC = () => {
  return (
    <div className="content">
      <header>
        <h1>Palette</h1>
      </header>

      <p>
        This page shows our palette for design on the site. Mostly for
        developers.
      </p>
      <section>
        <div className="palette-grid">
          {ICON_NAMES.map((icon) => (
            <PaletteEntry key={icon} icon={icon} />
          ))}
        </div>
      </section>
    </div>
  );
};

export { PalettePage };
